import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCoinBalance } from "../../redux/actions/coinsActions";

const CoinBalancePoller = () => {
  const dispatch = useDispatch();
  const intervalRef = useRef(null);
  const isAuthenticated = useSelector(
    (state) => !!state.user?.adoc_t && !!state.user?.user,
  );

  // Get polling interval from environment variable (default 2 minutes)
  const pollInterval =
    parseInt(process.env.REACT_APP_COINS_BALANCE_POLL_INTERVAL_MS) || 120000;

  useEffect(() => {
    if (!isAuthenticated) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    // Initial fetch
    dispatch(getCoinBalance());

    // Set up polling — only poll when app is visible
    intervalRef.current = setInterval(() => {
      if (!document.hidden) {
        dispatch(getCoinBalance());
      }
    }, pollInterval);

    // Cleanup on unmount or when authentication changes
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [dispatch, isAuthenticated, pollInterval]);

  return null;
};

export default CoinBalancePoller;
